<template>
    <div class="c-car-selectcar ">
        <div class="component">
            <h3 class="text--upper">Wybierz pojazd</h3>
            <div class="c-car-selectcar__container">
                <div class="flex-row">
                    <div class="flex-col">
                        <label class="mt--1">
                            <TypeSelect :options="getModels" :input="{disabled:!getModels,placeholder:'Model',sufix:''}" v-on:selectValue="lead.model_id = $event.id" :filterFunction="(value,search) => String(value.name.toLowerCase()).includes(search.toLowerCase())">
                                <template slot-scope="{option}">{{ option.name }}</template>
                            </TypeSelect>
                            <small class="text-error" v-if="!lead.model_id">To pole jest wymagane</small>
                        </label>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-col">
                        <label class="mt--1">
                            <span class="input-placeholder" :class="{'compleeted':lead.registration_number}">Nr rejestracyjny *</span>
                            <input type="text" name="registration_number" v-model="lead.registration_number">
                            <small class="text-error" v-if="!lead.registration_number">To pole jest wymagane</small>
                        </label>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-col">
                        <label class="mt--1">
                            <span class="input-placeholder" :class="{'compleeted':lead.vin}">Numer VIN *</span>
                            <input type="text" name="vin" v-model="lead.vin" maxlength="17">
                            <small class="text-error" v-if="!lead.vin">To pole jest wymagane</small>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="component">
            <div class="c-car-selectcar__container">
                <div class="flex-row">
                    <div class="flex-col">
                        <label class="mt--1">
                            <span class="input-placeholder" :class="{'compleeted':lead.mileage}">Stan licznika *</span>
                            <input type="number" name="mileage" v-model="lead.mileage">
                            <small class="text-error" v-if="!lead.mileage">To pole jest wymagane</small>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-row flex-row--end">
            <router-link to="/overview">
                <button class="btn btn--primary" :disabled="!validation.car">Dalej do przeglądu</button>
            </router-link>
        </div>
    </div>
</template>
<script>
    import lead from '@/mixins/lead.js'
    import { mapActions, mapGetters} from 'vuex'

    import TypeSelect from '../elements/type-select.vue'

    export default {
        mixins:[lead],
        components:{
            TypeSelect
        },
        computed:{
            ...mapGetters({
                getModels:'definitions/getModels'
            })
        },
        methods:{
            ...mapActions({
                fetchModels:'definitions/fetchModels'
            })
        },
        mounted(){
            this.fetchModels()
        }
    }
</script>
<style lang="scss" scoped>
    .c-car-selectcar{
        &__container{
            max-width: 1024px;
            margin: 0 auto;
        }
    }
</style>